<template src="./Add.html"></template>

<script>
export default {
  created() {

  },
  computed: {

    jobGroups() {
      return [
        ...this.$store.state.lookups.jobGroups
      ]
    },
  },
  data() {
    return {
      job: {
        isDoctor:false,
        jobDec:null
      },
    };
  },
  methods: {
    confirm() {
    
      this.$store
        .dispatch("jobs/add", this.job)
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },

    back() {
      this.$emit("back");
    },
  },
};
</script>